// extracted by mini-css-extract-plugin
export default {"container":"otp_container__nlWzW","input":"otp_input__-A9Df","error":"otp_error__TdSOF"};